import type { IOibPersonData } from "../../oib";
import type {
  CommitteeEmployee,
  OibFullInfoEmployee,
} from "../../../models/Committee";

export function buildOibPersonDataFromCommitteeEmployee(params: {
  employee: CommitteeEmployee | null | undefined;
  searchOibEmployee: OibFullInfoEmployee;
  handleSearchOibEmployeeChange: (
    value: string,
    key: keyof OibFullInfoEmployee
  ) => void;
}): IOibPersonData {
  const { employee, searchOibEmployee, handleSearchOibEmployeeChange } = params;

  return {
    lastNameValue:
      employee?.oibEmployee?.lastName ?? searchOibEmployee.lastName ?? "",
    onLastNameChange: (value: string) =>
      handleSearchOibEmployeeChange(value, "lastName"),
    firstNameValue:
      employee?.oibEmployee?.firstName ?? searchOibEmployee.firstName ?? "",
    onFirstNameChange: (value: string) =>
      handleSearchOibEmployeeChange(value, "firstName"),
  };
}
